import instance from 'utils/axios/instance.axios';
import { PROGRAMS } from './_constant';

// eslint-disable-next-line import/prefer-default-export
export const getAll = ({ forRequestUpdate }) =>
  instance.get(PROGRAMS.GET_ALL, { params: { forRequestUpdate } });
